import { useTranslation } from 'react-i18next'
import { Input } from 'reactstrap'
import activities from '../../api/activities/hooks'
import Loader from '../../Components/Common/Loader'

const ExternalEvents = ({ selectedActivityTypes, setSelectedActivityTypes, handleActivityTypeChange }) => {
    const { t } = useTranslation()

    const { rawData: activityValues } = activities.FormValues.useQuery()
    const activityTypes = activityValues?.type ?? []

    const onDrag = (event) => {
        event.preventDefault()
    }

    return (
        <div id="external-events">
            <br />
            <p className="text-muted">{t('activityCalendar.info')}</p>
            {activityTypes && activityTypes.length ? (
                activityTypes.map((category) => (
                    <div
                        className="external-event fc-event text-primary d-flex justify-content-between align-items-center"
                        style={{
                            // 2e hex suffix ≈ 18% alpha - faded tint so the label text stays readable
                            backgroundColor: `${category.color}2e`,
                        }}
                        key={'cat-' + category.id}
                        draggable
                        onDragEnter={(event) => {
                            onDrag(event, category)
                        }}
                        data-activity-type-id={category.id}
                        data-activity-type-name={category.name}
                    >
                        <div>
                            <i className="mdi mdi-checkbox-blank-circle font-size-11 me-2" style={{ color: category.color }} />
                            {category.name}
                        </div>
                        <div className="ms-2 form-check">
                            <Input
                                type="checkbox"
                                className="form-check-input"
                                id={category.name}
                                name={category.name}
                                value={category.id}
                                checked={selectedActivityTypes.includes(category.id.toString())}
                                onChange={(e) => {
                                    const newSelectedTypes = e.target.checked
                                        ? [...selectedActivityTypes, e.target.value]
                                        : selectedActivityTypes.filter((x) => x !== e.target.value)

                                    setSelectedActivityTypes(newSelectedTypes)
                                    handleActivityTypeChange(newSelectedTypes)
                                }}
                            />
                        </div>
                    </div>
                ))
            ) : (
                <Loader />
            )}
        </div>
    )
}

export default ExternalEvents
